import styled from 'styled-components';
import { colors } from '../../styles';
import PrimaryButton from './primary-button';

export default styled(PrimaryButton)`
  background: ${colors.white};
  border: 1px solid ${colors.green500};
  color: ${colors.green500};
  padding: 0;
  width: 10rem;
  height: 2rem;

  :hover {
    background: ${colors.green400};
    border: 1px solid ${colors.green500};
    color: white;
  }
  :focus {
    outline: none;
  }

  &[disabled],
  &.disabled {
    &,
    &:hover {
      background: ${colors.grey10};
      box-shadow: inset 0 0 2px ${colors.grey300};
      color: ${colors.grey300};
      cursor: default;
    }
  }
`;
